"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.protocols = void 0;
exports.protocols = (value) => value.substring(0, value.indexOf("://")).split("+").filter(Boolean);
//# sourceMappingURL=protocols.js.map